(function(app) {

    app.provider("annuityAccountApi",
        [
            function() {
                this.$get = [
                    "crmApiGateway", function(crmApiGateway) {
                        var service = {};

                        service.get = function(annuityAccountId) {
                            return crmApiGateway.get("/AnnuityAccounts/" + annuityAccountId);
                        }

                        service.getAnnuityAccounts = function() {
                            return crmApiGateway.getArray("/AnnuityAccounts");
                        }

                        service.getCaseAnnuityAccounts = function(caseId) {
                            return crmApiGateway.getArray("/Cases/" + caseId + "/AnnuityAccounts");
                        }

                        service.getCaseAnnuityAccountsComplete = function (caseId) {
                            return crmApiGateway.getArray("/Cases/" + caseId + "/AnnuityAccounts/Complete");
                        }

                        service.update = function(annuityAccountId, annuityAccount) {
                            return crmApiGateway.put("/AnnuityAccounts/" + annuityAccountId, annuityAccount);
                        }

                        service.create = function(annuityAccount) {
                            return crmApiGateway.post("/AnnuityAccounts", annuityAccount);
                        }

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line